import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  DcButton,
  DcDropDown,
  DcInput,
  PixelFactoryContext,
  PixelSwitch,
} from 'pixel-base'
import styled from 'styled-components'

import { post, put } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../decl.d'
const AddUpdateBankAccount = (props) => {
  const navigate = useNavigate()

  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { handleClose, details, alreadyAdded, countries } = props
  const [data, setData] = React.useState({
    bank_id: null,
    is_active: true,
    account_number: null,
    bank_name: null,
    iban: null,
    account_title: null,
    branch_code: null,
    account_type: null,
    is_business_account: true,
    bank_short_name: null,
    swift_code: null,
    banking_country: null,
    is_default: false,
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const USAccountTypes = [
    { value: 'savings', label: 'Savings' },
    { value: 'checking', label: 'Checking' },
  ]
  const PKAccountTypes = [
    { value: 'savings', label: 'Savings' },
    { value: 'current', label: 'Current' },
  ]
  const handleSubmit = (e) => {
    e.preventDefault()
    if (alreadyAdded) {
      handleUpdate()
    } else {
      addBankAccount()
    }
  }
  React.useEffect(() => {
    if (countries.default) {
      setData({
        ...data,
        banking_country: countries.default,
      })
    }
  }, [countries])
  const addBankAccount = () => {
    showPageLoader()
    post('/settings/bank-accounts', {
      bank_name: data.bank_name,
      account_number: data.account_number,
      iban: data.iban,
      account_title: data.account_title,
      branch_code: data.branch_code,
      account_type: data.account_type,
      is_business_account: data.is_business_account,
      bank_short_name: data.bank_short_name,
      swift_code: data.swift_code,
      banking_country: data.banking_country,
      is_default: data.is_default,
    }).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Bank account created successfully')
        navigate(`/finance/settings/bank-accounts/${res.response.data.bank_id}`)
        handleClose('new', res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  const handleUpdate = () => {
    showPageLoader()
    put(`/settings/bank-accounts/${data.bank_id}/update`, data).subscribe(
      (res: any) => {
        hidePageLoader()
        if (res.response.data) {
          showSuccess('Bank account updated successfully')
          handleClose('update', res.response.data)
        } else {
          if (res.response.error && res.response.field) {
            setError({
              error: res.response.error,
              field: res.response.field,
            })
          } else {
            showFailure(res.response.error)
          }
        }
      },
    )
  }
  React.useEffect(() => {
    if (alreadyAdded) {
      setData({
        ...data,
        bank_id: details.bank_id,
        bank_name: details.bank_name,
        iban: details.iban,
        account_title: details.account_title,
        account_number: details.account_number,
        banking_country: details.banking_country,
        account_type: details.account_type,
        is_business_account: details.is_business_account,
        bank_short_name: details.bank_short_name,
        swift_code: details.swift_code,
        is_default: details.is_default,
        branch_code: details.branch_code,
        is_active: details.is_active,
      })
    }
  }, [details])
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcDropDown
            error={
              error.field === 'is_business_account' && error.error !== ''
                ? error.error
                : null
            }
            label="Banking Country*"
            name="banking_country"
            value={data.banking_country}
            onChange={(e) => {
              setData({ ...data, banking_country: e.target.value })
            }}
            placeholder="Banking Country*"
            required
            options={[...countries.list].map((item: any) => {
              return {
                label: item.name,
                value: item.two_letter_abbreviation,
              }
            })}
          />
          <DcDropDown
            error={
              error.field === 'is_business_account' && error.error !== ''
                ? error.error
                : null
            }
            label="Business / Personal*"
            name="is_business_account"
            value={data.is_business_account}
            onChange={(e) => {
              setData({ ...data, is_business_account: e.target.value })
            }}
            placeholder="Business / Personal*"
            required
            options={[
              { value: true, label: 'Business' },
              { value: false, label: 'Personal' },
            ]}
          />
        </FormGroup>
        <FormGroup>
          <DcInput
            error={
              error.field === 'bank_name' && error.error !== ''
                ? error.error
                : null
            }
            label="Bank Name*"
            name="bank_name"
            value={data.bank_name}
            onChange={(e) => {
              setData({ ...data, bank_name: e.target.value })
            }}
            placeholder="Bank Name*"
            required
            maxLength={100}
          />
          <DcInput
            error={
              error.field === 'bank_short_name' && error.error !== ''
                ? error.error
                : null
            }
            label="Account Title*"
            name="account_title"
            value={data.account_title}
            onChange={(e) => {
              setData({ ...data, account_title: e.target.value })
            }}
            placeholder="Account Title*"
            required
            maxLength={200}
          />
        </FormGroup>
        <FormGroup>
          <DcInput
            error={
              error.field === 'bank_short_name' && error.error !== ''
                ? error.error
                : null
            }
            label="Account Short Name*"
            name="bank_short_name"
            value={data.bank_short_name}
            onChange={(e) => {
              setData({ ...data, bank_short_name: e.target.value })
            }}
            placeholder="Account Short Name*"
            required
            maxLength={45}
          />

          <DcDropDown
            error={
              error.field === 'account_type' && error.error !== ''
                ? error.error
                : null
            }
            label="Account Type*"
            name="account_type"
            value={data.account_type}
            onChange={(e) => {
              setData({ ...data, account_type: e.target.value })
            }}
            placeholder="Account Type*"
            required
            options={
              data.banking_country === 'US' ? USAccountTypes : PKAccountTypes
            }
          />
        </FormGroup>
        <FormGroup>
          <DcInput
            error={
              error.field === 'account_number' && error.error !== ''
                ? error.error
                : null
            }
            label="Bank Account Number*"
            name="account_number"
            value={data.account_number}
            onChange={(e) => {
              setData({ ...data, account_number: e.target.value })
            }}
            placeholder="Account Number*"
            required
            maxLength={45}
          />
          <DcInput
            error={
              error.field === 'iban' && error.error !== '' ? error.error : null
            }
            label="IBAN"
            name="iban"
            value={data.iban}
            required
            onChange={(e) => {
              setData({ ...data, iban: e.target.value })
            }}
            placeholder="IBAN"
            maxLength={45}
          />
        </FormGroup>
        <FormGroup>
          <DcInput
            error={
              error.field === 'branch_code' && error.error !== ''
                ? error.error
                : null
            }
            label="Branch Code"
            name="branch_code"
            value={data.branch_code}
            onChange={(e) => {
              setData({ ...data, branch_code: e.target.value })
            }}
            placeholder="Branch Code"
            maxLength={45}
          />
          <DcInput
            error={
              error.field === 'swift_code' && error.error !== ''
                ? error.error
                : null
            }
            label={data.banking_country === 'US' ? 'BIC Code' : 'Swift Code'}
            name="swift_code"
            value={data.swift_code}
            onChange={(e) => {
              setData({ ...data, swift_code: e.target.value })
            }}
            placeholder={
              data.banking_country === 'US' ? 'BIC Code' : 'Swift Code'
            }
            maxLength={45}
          />
        </FormGroup>
        <FormGroup>
          {alreadyAdded && (
            <PixelSwitch
              label="Active Status"
              name="is_active"
              checked={data.is_active}
              onChange={(e) => {
                e.target.checked
                  ? setData({ ...data, is_active: true })
                  : setData({ ...data, is_active: false })
              }}
            />
          )}
        </FormGroup>
        <FormGroup flexEnd>
          <DcButton
            type="submit"
            variant="primary"
            disabled={
              (data.bank_name &&
                data.account_title &&
                data.account_number &&
                data.banking_country &&
                data.account_type &&
                data.is_business_account &&
                data.bank_short_name) === null
                ? true
                : false
            }
          >
            {alreadyAdded ? 'Update' : 'Save'}
          </DcButton>
          <DcButton
            type="button"
            variant="outline-secondary"
            onClick={() => [handleClose('cancel', null)]}
          >
            Cancel
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`
const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
export default AddUpdateBankAccount
